import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import EdynLogo from './edyn_logo'

const Header = ({ siteTitle }) => (
  <header
    style={{
      background: `white`,
      marginBottom: `1.45rem`,
    }}
  >
    <Link to='/'>
      <EdynLogo />
    </Link>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
